/**************************** Cookies ****************************/

function setCookie({ name, value, days }) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `; expires=${ date.toUTCString() }`;

    document.cookie = `${ name }=${ value }; ${ expires }; path=/`;
}

function getCookie({ name }) {
    const nameEQ = `${ name }=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


/**************************** Helpers ****************************/

function tryFetchUrl({ url }) {
    return new Promise(resolve => {
        fetch(url, { method: 'GET' })
            .then((response) => resolve(response.ok))
            .catch(() => resolve(false));
    });
}

// Locale-aware validation: go to finalUrl if it exists, else fallback
async function validateUrl({ finalUrl, fallbackUrl }) {
    try {
        const urlObj = new URL(finalUrl);
        const jsonUrl = `${urlObj.origin}${urlObj.pathname}.json`;
        const ok = await tryFetchUrl({ url: jsonUrl });
        window.location.href = ok ? finalUrl : fallbackUrl;
    } catch {
        window.location.href = fallbackUrl;
    }
}

// Locale-aware redirect that preserves path, query, and hash
function redirectToSamePath({ url }) {
    // Ensure popup is closed whenever we redirect
    try {
        if (window.__GeoPopup) {
            window.__GeoPopup.closePopup({ setCookieValue: true });
        } else {
            const popupEl = document.getElementById('geo-popup');
            if (popupEl) popupEl.classList.add('hidden');
            if (window.scrollLock && window.scrollLock.enablePageScroll) {
                window.scrollLock.enablePageScroll();
            }
            setCookie({ name: 'geoDismissed', value: 1, days: 30 });
        }
    } catch(e) {}

    const currentUrl = new URL(window.location.href);

    // Normalize input URL: support absolute, origin-relative, and path-relative inputs
    const redirectUrl = new URL(typeof url === 'string' ? url : String(url), window.location.origin);

    const getLocale = (path) => {
        const m = path.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i);
        return m ? m[1] : null;
    };

    const currentLocale = getLocale(currentUrl.pathname);
    const targetLocale  = getLocale(redirectUrl.pathname);

    // Remove current locale prefix from current path
    let restPath = currentUrl.pathname;
    if (currentLocale) {
        restPath = restPath.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i, '');
        if (!restPath) restPath = '/';
    }

    // Build target path using the target locale, if present on the clicked link
    let targetPath;
    if (targetLocale) {
        targetPath = '/' + targetLocale + (restPath === '/' ? '' : restPath);
    } else {
        targetPath = restPath;
    }

    const finalUrl = `${redirectUrl.origin}${targetPath}${currentUrl.search}${currentUrl.hash}`;
    const fallbackUrl = `${redirectUrl.origin}${redirectUrl.pathname}`;

    // Avoid useless reloads
    if (finalUrl === window.location.href) return;

    validateUrl({ finalUrl, fallbackUrl });
}

function populateStoreElem({ htmlTemplate, storeData, settings }) {

    if (htmlTemplate && storeData && settings) {

        const htmlTemplateImg = htmlTemplate.querySelector('[data-store-image]');
        const htmlTemplateText = htmlTemplate.querySelector('[data-store-title]');

        if (storeData.link) {
            htmlTemplate.setAttribute('href', storeData.link);

            // Close popup first, then redirect (preserve path)
            htmlTemplate.addEventListener('click', (event) => {
                event.preventDefault();

                try {
                    if (window.__GeoPopup) {
                        window.__GeoPopup.closePopup({ setCookieValue: true });
                    } else {
                        const popupEl = document.getElementById('geo-popup');
                        if (popupEl) popupEl.classList.add('hidden');
                        if (window.scrollLock && window.scrollLock.enablePageScroll) {
                            window.scrollLock.enablePageScroll();
                        }
                        setCookie({ name: 'geoDismissed', value: 1, days: 30 });
                    }
                } catch(e) {}

                // Next tick to let CSS apply
                setTimeout(() => {
                    redirectToSamePath({ url: storeData.link });
                }, 0);
            });

        }

        htmlTemplate.setAttribute('title', storeData.title);

        if (storeData['highlight'] !== null && storeData.highlight === true) {
            htmlTemplate.classList.add('highlight');
        }

        if (settings.showImage && storeData.imageSrc) {
            htmlTemplateImg.setAttribute('src', storeData.imageSrc);
            htmlTemplateImg.setAttribute('alt', storeData.title);

            if (settings.lazyLoadImage) {
                htmlTemplateImg.setAttribute('loading', 'lazy');
            } else {
                /***
                 * Preloads image, so it is displayed faster
                 */
                (new Image()).src = storeData.imageSrc;
            }
        }
        else {
            htmlTemplateImg.remove();
        }

        switch (settings.showTitle) {
            case 'title':
                htmlTemplateText.innerText = storeData.title;
                break;

            case 'dropdown_title':
                htmlTemplateText.innerText = storeData.dropdownTitle;
                break;

            case 'country_code':
                if (storeData.countryCodes.length > 0) {
                    htmlTemplateText.innerText = storeData.countryCodes[0];
                } else {
                    if (storeData.title) {
                        htmlTemplateText.innerText = storeData.title;
                    } else {
                        htmlTemplateText.innerText = storeData.dropdownTitle;
                    }
                }
                break;

            default:
                htmlTemplateText.remove();
                break;
        }

        return htmlTemplate;
    }
    else {
        return null;
    }

}


/**************************** Popup ****************************/

class GeoPopup {
    constructor(main, data, geoData, forceOpen) {
        this.data = {
            countryCode: data.country_code,
            continentCode: data.continent_code,
            stores: data.stores,
            currentStore: data.stores.find(x => x.isCurrentStore == true),
            externalStores: data.stores.filter(x => x.isCurrentStore == false),
            geo: geoData
        }

        this.settings = data.popupSettings;

        this.forceOpen = forceOpen;

        this.dom = {
            popup: main,
            headline: main.querySelector('[data-template="headline"]'),
            subheading: main.querySelector('[data-template="subheading"]'),
            currentStoreTemplate: main.querySelector('[data-template="current-store"]'),
            externalStoreTemplate: main.querySelector('[data-template="external-store"]'),
            externalStoresContainer: main.querySelector('[data-template="stores-container"]'),
            fragment: document.createDocumentFragment()
        }

        this.init();

        // Expose instance so other code can close it before redirects
        window.__GeoPopup = this;
    }


    init() {

        /***
         * Check if there is a matching Ase Alpha-2 code from GeoJs 
         */

        this.data.storeMatch = this.getStoreMatch();

        if (this.data.storeMatch && this.data.storeMatch != null) {
            /***
             * If storeMatch is also the current store, set cookie and stop
             */
            if (this.data.storeMatch.isCurrentStore === true && this.forceOpen === false ) {
                return setCookie({ name: 'geoDismissed', value: 1, days: 30 });
            }
            else{
                this.forceOpen = true;
            }

            this.build({ hasMatch: true});
        }
        else {
            this.build({});
        }
    }

    build({ hasMatch = false}) {

        this.setHeadline({ hasMatch });
        this.imageSettings();

        if (hasMatch) {
            this.geoMatchSettings();
        }

        this.addCurrentStoreToPopup();
        this.addExternalStoresToPopup();
        this.attacheListeners();

        window.GeoPopupIsInit = true;

        /**
         * Shows the popup
         */
        if (this.forceOpen === true) {
            this.openPopup();
        }
    }

    getStoreMatch() {

        if (!this.data.geo) return null;
        if (this.data.stores.some(x => x.countryCodes.includes(this.data.geo.country_code))) {
            /***
            * Get store match
            */
            return this.data.stores.find(x => x.countryCodes.includes(this.data.geo.country_code));
        }
        if (this.data.stores.some(x => x.countryCodes.includes(this.data.geo.continent_code))) {
            /***
             * Get continental match - is handy is there is no store match, 
             * or if the store ships to a whole continent, then its easier to setup
             */
            return this.data.stores.find(x => x.countryCodes.includes(this.data.geo.continent_code));
        }
        if (this.data.stores.some(x => x.isInternational == true)) {
            /***
             * Get internatinal store - Last resort, if nothing else matches 
             */
            return this.data.stores.find(x => x.isInternational == true);
        }
    }

    setHeadline({ hasMatch }) {

        if (hasMatch && this.data.storeMatch.popup.headline && this.data.storeMatch.popup.subheading) {
            this.dom.headline.innerText = this.data.storeMatch.popup.headline;
            this.dom.subheading.innerText = this.data.storeMatch.popup.subheading;
        }
        else {
            this.dom.headline.innerText = this.data.currentStore.popup.headline;
            this.dom.subheading.innerText = this.data.currentStore.popup.subheading;
        }
    }

    imageSettings() {
        if (this.settings.imagePosition === 'right') {
            this.dom.popup.classList.add('image-position--right');
        }
        if (this.settings.roundedImages) {
            this.dom.popup.classList.add('images--rounded');
        }
        if (this.settings.showLanguageTitle === 'none') {
            this.dom.popup.classList.add('images--only');
        }
    }

    geoMatchSettings() {

        switch (this.settings.geoMatch) {
            case 'highlight':
                const index = this.data.externalStores.findIndex(x => x === this.data.storeMatch);

                if (index >= 0) {
                    this.data.externalStores[index].highlight = true;
                }
                break;

            case 'matchOnly':
                if (this.data.storeMatch) {
                    /**
                     * Sets the match as array, so its does not break forach loops
                     */
                    this.data.externalStores = [this.data.externalStores.find(x => x === this.data.storeMatch)];
                }
                break;
        }
    }

    addCurrentStoreToPopup() {
        if (this.dom.currentStoreTemplate) {
            populateStoreElem(
                {
                    htmlTemplate: this.dom.currentStoreTemplate,
                    storeData: this.data.currentStore,
                    settings: {
                        showTitle: this.settings.showLanguageTitle,
                        showImage: this.settings.showImages,
                        lazyLoadImage: false
                    }
                }
            );
        }

    }

    addExternalStoresToPopup() {
        if (this.dom.externalStoreTemplate) {
            this.data.externalStores.forEach(externalStore => {
                const template = this.dom.externalStoreTemplate.cloneNode(true);

                this.dom.fragment.appendChild(
                    populateStoreElem(
                        {
                            htmlTemplate: template,
                            storeData: externalStore,
                            settings: {
                                showTitle: this.settings.showLanguageTitle,
                                showImage: this.settings.showImages,
                                lazyLoadImage: false,
                            }
                        }
                    )
                );
            });

            this.dom.externalStoreTemplate.remove();
            this.dom.externalStoresContainer.appendChild(this.dom.fragment);
        }
    }

    attacheListeners() {

        /**
         * Close listeneres
         */
        this.dom.popup.querySelectorAll('[data-action="close"]').forEach(closeElement => {
            closeElement.addEventListener('click', () => {
                this.closePopup({ setCookieValue: true });
            });
        });

        /**
         * Dismiss listeners
         */

        this.dom.popup.querySelectorAll('[data-action="dismiss"]').forEach(closeElement => {
            closeElement.addEventListener('click', () => {
                this.closePopup({ setCookieValue: true });
            });
        });


        /**
         * Open listeners
         */

        document.addEventListener('geoPopup:open', () => {
            this.openPopup();
        });

    }
    attacheCloseListeners() {
        this.dom.popup.querySelectorAll('[data-action="close"]').forEach(closeElement => {
            closeElement.addEventListener('click', () => {
                this.closePopup({ setCookieValue: true });
            });
        });
    }

    attacheDismissListeners() {
        this.dom.popup.querySelectorAll('[data-action="dismiss"]').forEach(closeElement => {
            closeElement.addEventListener('click', () => {
                this.closePopup({ setCookieValue: true });
            });
        });

    }

    openPopup() {
        this.dom.popup.classList.remove('hidden');
        window.scrollLock.disablePageScroll();
    }

    closePopup({ setCookieValue }) {
        this.dom.popup.classList.add('hidden');
        window.scrollLock.enablePageScroll();

        if (setCookieValue) {
            setCookie({ name: 'geoDismissed', value: 1, days: 30 });
        }
    }
}


/**************************** Dropdown ****************************/

class GeoDropdown {
    constructor(main, storeData) {

        if (storeData['stores']) {
            this.data = {

                currentStore: storeData.stores.find(x => x.isCurrentStore == true),
                externalStores: storeData.stores.filter(x => x.isCurrentStore == false),
            }
        }

        if (storeData['dropdownSettings']) {
            this.settings = storeData.dropdownSettings;
        }

        this.dom = {
            fragment: document.createDocumentFragment(),
            dropdown: main,
            currentStoreHeaderElement: main.querySelector('[data-template="current-store-header"]'),
            currentStoreElement: main.querySelector('[data-template="current-store"]'),
            externalStoreElement: main.querySelector('[data-template="external-store"]'),
            storesContainer: main.querySelector('[data-template="stores-container"]'),
            openElements: main.querySelectorAll('[data-action="open"]'),
            closeElements: main.querySelectorAll('[data-action="close"]'),
            toggleElements: main.querySelectorAll('[data-action="toggle"]')
        }

        this.init();

        if (this.error) {
            this.dom.dropdown.style.display = 'none';
        }
    }


    attacheEventliteners() {

        if (this.dom.openElements) {
            this.dom.openElements.forEach((openElement) => {
                openElement.addEventListener('click', () => {
                    this.openDropdown();
                });
            });
        }

        if (this.dom.closeElements) {
            this.dom.closeElements.forEach((closeElement) => {
                closeElement.addEventListener('click', () => {
                    this.closeDropdown();
                });
            });
        }

        if (this.dom.toggleElements) {
            this.dom.toggleElements.forEach((toggleElement) => {
                toggleElement.addEventListener('click', () => {

                    if (this.dom.dropdown.classList.contains('open')) {
                        this.closeDropdown();
                    } else {
                        this.openDropdown();
                    }

                });
            });
        }

        /*Close when clicking outside */
        document.addEventListener('click', (event) => {
            var isClickInside = this.dom.dropdown.contains(event.target);

            if (!isClickInside) {
                this.closeDropdown();
            }
        });
    }


    applySettings() {
        if (this.settings.imagePosition === 'right') {
            this.dom.dropdown.classList.add('image-position--right');
        }
        if (this.settings.roundedImages) {
            this.dom.dropdown.classList.add('images--rounded');
        }
    }

    addCurrentStoreToDropdown() {

        if (this.data.currentStore) {
            // Add content to Dropdown - Current store header

            populateStoreElem({
                htmlTemplate: this.dom.currentStoreHeaderElement,
                storeData: this.data.currentStore,
                settings: {
                    showTitle: this.settings.showLanguageTitleInHeader,
                    showImage: this.settings.showImages,
                    lazyLoadImage: false,
                    isDropdown: true
                }
            });

            // Add content to Dropdown - Current store
            populateStoreElem({
                htmlTemplate: this.dom.currentStoreElement,
                storeData: this.data.currentStore,
                settings: {
                    showTitle: this.settings.showLanguageTitleInContent,
                    showImage: this.settings.showImages,
                    lazyLoadImage: true,
                    isDropdown: true
                }
            });
        }
    }

    addExternalStoresToDropdown() {
        // Add content to Dropdown - External stores
        if (this.data.externalStores) {
            this.data.externalStores.forEach(externalStore => {
                const template = this.dom.externalStoreElement.cloneNode(true);
                // template.removeAttribute('data-template');
                this.dom.fragment.appendChild(
                    populateStoreElem(
                        {
                            htmlTemplate: template,
                            storeData: externalStore,
                            settings: {
                                showTitle: this.settings.showLanguageTitleInContent,
                                showImage: this.settings.showImages,
                                lazyLoadImage: true,
                                isDropdown: true
                            }
                        })
                );
            });
        }

        this.dom.externalStoreElement.remove();
        this.dom.storesContainer.appendChild(this.dom.fragment);
    }

    init() {

        this.attacheEventliteners();
        this.applySettings();
        this.addCurrentStoreToDropdown();
        this.addExternalStoresToDropdown();
    }

    openDropdown() {

        if (this.settings.openDropdownAsPopup === true) {
            if (window.GeoPopupIsInit) {
                document.dispatchEvent(new CustomEvent('geoPopup:open'));
            }
            else {
                initGeoPopup({ forceOpen: true });
            }
        }
        else {
            this.dom.dropdown.classList.add('open');
        }
    }

    closeDropdown() { this.dom.dropdown.classList.remove('open'); }
}

const currentUrl = window.location.href;
console.log('currentUrl', currentUrl);
let currentUrlContains;

if(currentUrl.indexOf('https://www.glerups.com/pages/innersoles') == -1) { 
//currentUrlContains = "URl indeholder Ikke our-design";
//console.log('URl contains', currentUrlContains);

function initGeoPopup({ forceOpen = false }) {
    fetch(`https://get.geojs.io/v1/ip/geo.json`, { mode: 'cors' })
        .then((r) => r.json())
        .then((geoData) => {

            /***
             * build Geo Popup
             * window.storesData is defined in geo-data.liquid
            */ 
            const popupElement = document.getElementById('geo-popup');
            if (window.storesData && popupElement) {
                void new GeoPopup(popupElement, window.storesData, geoData, forceOpen); 
            }
        });
} 
 
}



/* =========================================== */

const geoDropdownElements = document.querySelectorAll('[data-template="dropdown"]');
if (geoDropdownElements && window.storesData) {
    geoDropdownElements.forEach((geoDropdownElement) => {
        void new GeoDropdown(geoDropdownElement, window.storesData);
    });
}

if (!getCookie({ name: 'geoDismissed' })) {
    initGeoPopup({});
}
